import React from "react";
import { Link, useLocation } from "react-router-dom";

const TopBar = ({ isLoggedIn, onLogout }) => {
  const location = useLocation(); // ✅ moved inside component

  if (!isLoggedIn) {
    return (
      <div className="top-bar">
       <div><Link to="/" className="nav-link">Home</Link></div>
      </div>
    )
  }

  return ( 
    <div className="top-bar">
      {location.pathname === "/manage" ? (
        <div><Link to="/" className="nav-link">Create New Invitation</Link></div>
      ) : (
        <div><Link to="/manage" className="nav-link">Manage Events</Link></div>
      )}
      
      <div>
        {isLoggedIn ? (
          <button onClick={onLogout}>Logout</button>
        ) : (
          <span style={{ fontStyle: "italic", color: "#666" }}>Not logged in</span>
        )}
      </div>
    </div>
  );
};

export default TopBar;
